/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gift_Intro_P1Inputs */

const es_gift_intro_p1 = /** @type {(inputs: Gift_Intro_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las tarjetas regalo de Zarpar sirven para cualquier alquiler o experiencia en la plataforma. El destinatario elige la salida, la fecha y el barco que le encaje.`)
};

const gl_gift_intro_p1 = /** @type {(inputs: Gift_Intro_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As tarxetas agasallo de Zarpar serven para calquera alugueiro ou experiencia na plataforma. O destinatario elixe a saída, a data e o barco que lle encaixe.`)
};

const en_gift_intro_p1 = /** @type {(inputs: Gift_Intro_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarpar gift cards work for any rental or experience on the platform. The recipient picks the trip, date and boat.`)
};

/**
* | output |
* | --- |
* | "Zarpar gift cards work for any rental or experience on the platform. The recipient picks the trip, date and boat." |
*
* @param {Gift_Intro_P1Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const gift_intro_p1 = /** @type {((inputs?: Gift_Intro_P1Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gift_Intro_P1Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_gift_intro_p1(inputs)
	if (locale === "en") return en_gift_intro_p1(inputs)
	return es_gift_intro_p1(inputs)
});